<template>
    <div ref="editor">
      <div id="toolbar">
        <span v-show="!disabled" class="ql-formats">
          <button @click.stop="toggleDialogEmoji">😃</button>
        </span>
        <span v-show="!disabled" class="ql-formats">
          <button @click="addVariable">➕ Adicionar variável</button>
        </span>
      </div>
      <div id="editor"></div>
      <div v-show="!disabled" class="alert alert-primary obs-span">
        Para negrito, envolva a palavra em asteriscos <strong>( * )</strong>.   Exemplo: *palavra* <br/>
        Para itálico, envolva a palavra em underlines <strong>( _ )</strong>.   Exemplo: _palavra_ <br/>
        Para sublinhado, envolva a palavra em til <strong>( ~ )</strong>.   Exemplo: ~palavra~ <br/>
        <strong>Obs: </strong> Não adicione espaços entre os caracteres especiais e a palavra.
      </div>
      <div :hidden="dialogHidden" class="emoji-frame" ref="emojiPicker">
        <VEmojiPicker @select="selectEmoji" :i18n="i18n"/>
      </div>
    </div>
  </template>
  
  <script>
  import Quill from "quill";
  import "quill/dist/quill.core.css";
  import "quill/dist/quill.snow.css";
  import "quill/dist/quill.bubble.css";
  import { VEmojiPicker } from 'v-emoji-picker';
  import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';
  
  export default {
    name: "CustomEditor",
    props: ['removeVariable', 'bodyText', 'templateVariables', 'selectingTemplate', 'disabled', 'refreshingTemplate'],
    data() {
      return {
        dialogHidden: true,
        editor: null,
        i18n: {
            search: 'Pesquisar...',
            categories: {
                Activity: "Atividades",
                Flags: "Bandeiras",
                Foods: "Comida",
                Frequently: "Frequentes",
                Objects: "Objetos",
                Nature: "Natureza",
                Peoples: "Pessoas",
                Symbols: "Símbolos",
                Places: "Locais"
            }
        },
        variablesList: [],
        removing: false
      };
    },
    components: {
        VEmojiPicker
    },
    methods: {
      toggleDialogEmoji() {
        this.dialogHidden = !this.dialogHidden;
        if (!this.dialogHidden) {
          document.addEventListener('click', this.handleClickOutsideEmojiPicker);
        }
      },
      handleClickOutsideEmojiPicker(event) {
        if (this.$refs.emojiPicker && !this.$refs.emojiPicker.contains(event.target)) {
          this.dialogHidden = true;
          document.removeEventListener('click', this.handleClickOutsideEmojiPicker);
        }
      },
      selectEmoji(dataEmoji) {
        const caretPosition = this.editor.getSelection().index;
        if(caretPosition){
          this.editor.insertText(caretPosition, dataEmoji.data);
        } else {
          this.editor.insertText(this.editor.getText().length - 1, dataEmoji.data)
        }
        
        this.toggleDialogEmoji();
      },
      addVariable() {
        if (this.editor.getSelection() === null) {
          return;
        }
        let parsedVariable = null;
        if(!this.variablesList.length){
          parsedVariable = '1️⃣';
          this.variablesList.push({id: parsedVariable, text: ''});
        } else {
          const nullId = this.variablesList.find(variable => variable.id === null);
          if(nullId){
            const index = this.variablesList.indexOf(nullId);
            parsedVariable = this.parseVariable(index + 1);
            this.variablesList[index].id = parsedVariable;
            this.variablesList[index].text = '';
          } else {
            parsedVariable = this.parseVariable(this.variablesList.length + 1);
            this.variablesList.push({id: parsedVariable, text: ''});
          }
        }
        const caretPosition = this.editor.getSelection().index;
        this.editor.insertText(caretPosition, parsedVariable);
        this.updatedVariable();
        return;
      },
      updatedVariable(){
        this.$emit('updatedVariable', this.variablesList);
      },
      parseVariable(index){
        if(index === 1) return '1️⃣';
        if(index === 2) return '2️⃣';
        if(index === 3) return '3️⃣';
        if(index === 4) return '4️⃣';
        if(index === 5) return '5️⃣';
        if(index === 6) return '6️⃣';
        if(index === 7) return '7️⃣';
        if(index === 8) return '8️⃣';
        if(index === 9) return '9️⃣';
        if(index === 10) return '🔟';
      },
    },
    mounted() {
      let options = {
        modules: {
          toolbar: "#toolbar"
        },
        placeholder: "Digite o texto aqui...",
        theme: "snow"
      };

      this.editor = new Quill("#editor", options);
    },
    computed: {
      emojisNative() {
        return packEmoji;
      },
      editorText() {
        if (!this.editor || this.editor.getText().trim() === '') return "";
        const delta = this.editor.getContents();
        const converter = new QuillDeltaToHtmlConverter(delta.ops, {});
        const html = converter.convert();
        return html;
      },
    },
    watch: {
      'editorText': function(newVal, oldVal) {
        const oldVariables = oldVal.match(/1️⃣|2️⃣|3️⃣|4️⃣|5️⃣|6️⃣|7️⃣|8️⃣|9️⃣|🔟/g) || [];
        const newVariables = newVal.match(/1️⃣|2️⃣|3️⃣|4️⃣|5️⃣|6️⃣|7️⃣|8️⃣|9️⃣|🔟/g) || [];
        if (oldVariables.length > newVariables.length && !this.removing && !this.selectingTemplate && !this.refreshingTemplate) {
          oldVal = oldVal.replace(/<br\s*\/?>/gi, "\n");
          oldVal = oldVal.replace(/<[^>]+>/g, "");
          this.editor.setText(oldVal);
          Swal.fire({
              type: 'error',
              title: 'Remover variável',
              text: 'Variáveis devem ser removidas na listagem abaixo',
          });
        }
        this.$emit('writing', {html: newVal, text: this.editor.getText()});
      },
      bodyText(newVal){
        const emojiNumbers = ['1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟'];
        newVal = newVal.replace(/\{\{(\d+)\}\}/g, function(match, number) {
          return emojiNumbers[number - 1] || match;
        });

        this.editor.setText(newVal);
      },
      removeVariable(variableId) {
        this.removing = true;

        if(variableId){
          const variable = this.variablesList.find(variable => variable.id === variableId);
          if(variable){
            const index = this.variablesList.indexOf(variable);
            this.variablesList[index].id = null;
            this.variablesList[index].text = '';

            const editorText = this.editor.getText();
            const newText = editorText.replace(variableId, '');
            this.editor.setText(newText);

            this.updatedVariable();
          }
        }
        
        setTimeout(() => {
            this.removing = false;
        }, 0);
      },
      templateVariables(newVal){
        if(!newVal.length){
          this.variablesList = [];
        } else {
          this.variablesList = newVal;
        }
        this.updatedVariable();
      },
      disabled(newVal) {
        if (this.editor) {
          this.editor.enable(!newVal);
        }
      },
      refreshingTemplate(newVal) {
        if(newVal){
          this.editor.setText('');
        }
      }
    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#counter {
    border: 1px solid #ccc;
    border-top: 0;
    padding: 0.5rem 1rem;
    text-align: right;
}
.emoji-frame{
    position: absolute;
    z-index:1;
    margin-top: -60px;
    margin-left: 120px;
    background-color: #f6f6f6;
}
#editor {
    background-color: white;
}

.ql-formats {
    margin: 0 !important;

    button {
        height: unset;
        white-space: nowrap;
    }
}

.obs-span {
  font-size: x-small;
  margin: 3px;
  padding: 3px;
}
</style>
  